import React from "react";

export const useScrollToTop = <T extends HTMLElement = HTMLElement>(
  existingRef?: React.RefObject<T>,
) => {
  const internalRef = React.useRef<T>(null);
  const scrollCallbackRef = existingRef || internalRef;
  const scrollToTop = () => {
    scrollCallbackRef.current?.scrollIntoView({ behavior: "instant" });
    scrollCallbackRef.current?.focus();
  };
  return [scrollCallbackRef, scrollToTop] as const;
};
